import { DatagridProps } from 'shared/react-admin/Datagrids';

import {
  DatagridStyled,
  GatewayRuleMappingDatagridEmpty,
} from './GatewayRuleMappingDatagrid.styled';

export function GatewayRuleMappingDatagrid({
  children,
  isLoading,
  bulkActionButtons = false,
  empty = <GatewayRuleMappingDatagridEmpty>Шлюзы не добавлены</GatewayRuleMappingDatagridEmpty>,
  ...restProps
}: DatagridProps): JSX.Element {
  return (
    <DatagridStyled
      bulkActionButtons={bulkActionButtons}
      empty={empty}
      isLoading={isLoading}
      {...restProps}
    >
      {children}
    </DatagridStyled>
  );
}
